import { render, staticRenderFns } from "./MessageListDialog.vue?vue&type=template&id=3700dadb&scoped=true&"
import script from "./MessageListDialog.vue?vue&type=script&lang=js&"
export * from "./MessageListDialog.vue?vue&type=script&lang=js&"
import style0 from "./MessageListDialog.vue?vue&type=style&index=0&id=3700dadb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3700dadb",
  null
  
)

export default component.exports